import {projects, runningActivity, sendStartActivity, sendStopActivity} from "../../api";
import {EventBus} from "../../utils";

export default {
    state: {
        mineProjects: [],
        running: false,
        runningActivity: {},
    },


    mutations: {
        setMineProjects(state, payload) {
            console.log('setMineProjects payload = ', payload);
            state.mineProjects = payload;
        },

        setRunning(state, payload) {
            console.log('setRunning payload =', payload);
            state.running = payload
        },

        setRunningActivity(state, payload) {
            console.log('runningActivity payload =', payload);
            state.runningActivity = payload
        },
    },


    actions: {
        fetchMineProjects(context, variables) {
            let token = context.getters.getToken;
            return projects({token, done: variables.done, all: variables.all, search: variables.search})
                    .then(response => {
                        context.commit("setMineProjects", response.data);
                        EventBus.$emit('projects.fetched_mine', response.data);
                    })
                    .catch((err) => EventBus.$emit('projects.fetched_mine_fail', err))
        },

        startActivity(context, payload) {
            return sendStartActivity(context.getters.getToken.jwt, payload)
                    .then(() => {
                        context.commit('setRunning', true)
                    })
        },

        stopActivity(context, payload) {
            return sendStopActivity(context.getters.getToken.jwt, payload)
                    .then(() => {
                        context.commit('setRunning', false)
                    })
        },

        fetchRunningActivity(context) {
            return runningActivity(context.getters.getToken.jwt)
                    .then(response => {
                        EventBus.$emit("fetchRunningActivity", response.data);
                        context.commit('setRunningActivity', response.data)
                    })
        },
    },

    getters: {
        hasRunningJob(state) {
            return state.running === true
        }
    }
}